import moment from 'moment';
//Components
import { ResizeObserver } from 'resize-observer';
//Constants
import { CHANNELS_IMAGES } from 'types/ChannelsImages';
import { userDetailStateName } from '../../users';
import { GROWTH_ACTIVE_MESSAGE_WA_SENT_ACTIVE_MESSAGE_BUTTON_CLICKED, } from '../../growth/GrowthSegmentEvents';
import { CONTACT_OPENED_TRACK, DOWNLOAD_CONTACTS_TRACK, EXPORT_ERROR_MESSAGE, APPLICATION_ORIGIN, FILE_NAME_DATE_FORMAT, ERROR_GENERATING_AUDIENCE_TITLE, ERROR_GENERATING_AUDIENCE_BODY, REFRESH_BUTTON_TEXT, STATE_ID_START, } from './Constants';
import { SUCCESS_STATUS, FAILURE_STATUS } from 'modules/application/misc/SegmentService';
import { CONTACTS_SIDE_BAR_ID, CONTACTS_USERS_PER_TAKE } from './Constants';
import { createJourneyTrack, getNodeNameAndPercentage } from './utils/contactsJourneyUtils';
import { ActiveMessagesFeatures } from '../../growth/activeMessages/ActiveMessagesFeatures';
//Constants
import { ActiveMessagesConstants } from '../../growth/activeMessages/ActiveMessagesConstants';
import { toCamelCase } from 'data/string';
export class ContactsJourneySideBarController {
    static $inject = ['SidebarContentService', 'selectedEdge', 'searchPeriod', 'firstNode', 'dataSource', 'selectedNodeUsersCount', 'ContactsJourneyService', '$state', '$window', 'UsersService', 'SegmentService', 'application', '$timeout', 'isShowingCSVExportButton', 'ngToast', 'TranslateService', 'ActiveMessageService', 'GrowthSegmentService', 'BlipToastService'];
    constructor(SidebarContentService, selectedEdge, searchPeriod, firstNode = STATE_ID_START, dataSource, selectedNodeUsersCount, ContactsJourneyService, $state, $window, UsersService, SegmentService, application, $timeout, isShowingCSVExportButton, ngToast, TranslateService, ActiveMessageService, GrowthSegmentService, BlipToastService) {
        'ngInject';
        this.SidebarContentService = SidebarContentService;
        this.selectedEdge = selectedEdge;
        this.searchPeriod = searchPeriod;
        this.firstNode = firstNode;
        this.dataSource = dataSource;
        this.selectedNodeUsersCount = selectedNodeUsersCount;
        this.ContactsJourneyService = ContactsJourneyService;
        this.$state = $state;
        this.$window = $window;
        this.UsersService = UsersService;
        this.SegmentService = SegmentService;
        this.application = application;
        this.$timeout = $timeout;
        this.isShowingCSVExportButton = isShowingCSVExportButton;
        this.ngToast = ngToast;
        this.TranslateService = TranslateService;
        this.ActiveMessageService = ActiveMessageService;
        this.GrowthSegmentService = GrowthSegmentService;
        this.BlipToastService = BlipToastService;
        this.edgeContacts = [];
        this.isLoading = false;
        this.lastPageReached = false;
        this.isGeneratingCSV = false;
        this.init();
    }
    async init() {
        this.setSideBarPositioning();
        this.getSummaryDataFromSelectedEdge();
        this.listenForEventToCloseSidebar();
        await this.checkFeatures();
    }
    listenForEventToCloseSidebar() {
        document.getElementById('contacts-journey-view').addEventListener('click', (e) => {
            if (!e.target.id || e.target.id != 'open-contacts-button') {
                if (this.isContactsSideBarOpened()) {
                    this.closeSidebar();
                }
            }
        });
    }
    isContactsSideBarOpened() {
        const openedSideBars = this.SidebarContentService.getSidebars();
        return openedSideBars.find(sideBar => {
            return sideBar.sidebarId == CONTACTS_SIDE_BAR_ID;
        });
    }
    setChannelsImagesToEdgeContacts() {
        this.edgeContacts.forEach((contact) => {
            if (contact.source) {
                const sourceData = CHANNELS_IMAGES.find((channel) => {
                    return channel.channel.toLocaleLowerCase() == contact.source.toLocaleLowerCase();
                });
                contact.sourceImage = sourceData && sourceData.src;
            }
        });
    }
    getSummaryDataFromSelectedEdge() {
        const { selectedNodeName, selectedNodePercentage } = getNodeNameAndPercentage(this.selectedEdge.name);
        const firstEdge = this.selectedEdge.step == 0;
        this.selectedEdgeName = selectedNodeName;
        this.selectedEdgeContactsCount = this.selectedNodeUsersCount;
        this.selectedEdgeContactsPercentage = firstEdge ? '(100%)' : `(${selectedNodePercentage})`;
    }
    async closeSidebar() {
        this.$timeout(() => this.SidebarContentService.cleanAndClose(false), 0);
    }
    goToContactDetails(identity) {
        let behavior = SUCCESS_STATUS;
        try {
            if (!identity) {
                return;
            }
            const id = this.UsersService.getDecodedUserIdentity(identity);
            const contactUrl = this.$state.href(userDetailStateName, { id });
            this.$window.open(contactUrl, '_blank');
        }
        catch (e) {
            behavior = FAILURE_STATUS;
        }
        finally {
            const contactOpenedTrackBody = {
                behavior,
                nodeType: this.selectedEdge.type,
                nodeName: this.selectedEdge.name,
            };
            createJourneyTrack(this.SegmentService, this.application, CONTACT_OPENED_TRACK, contactOpenedTrackBody);
        }
    }
    setSideBarDistanceFromTop() {
        const sidebarElement = document.getElementById('contacts-journey-side-bar');
        if (sidebarElement) {
            const navBarElement = document.getElementById('main-navbar');
            const distanceFromTop = navBarElement.offsetHeight;
            sidebarElement.style.top = `${distanceFromTop.toString()}px`;
            const sidebarHeight = this.$window.innerHeight - navBarElement.offsetHeight;
            sidebarElement.style.height = `${sidebarHeight.toString()}px`;
        }
    }
    setSideBarPositioning() {
        this.setSideBarDistanceFromTop();
        const resizeObserver = new ResizeObserver(() => {
            this.setSideBarDistanceFromTop();
        });
        const navBarElement = document.getElementById('main-navbar');
        resizeObserver.observe(navBarElement);
    }
    async loadMore() {
        if (this.isLoading) {
            return;
        }
        try {
            if (!this.lastPageReached) {
                this.isLoading = true;
                await this.getEdgeContacts();
            }
        }
        catch (error) {
            this.lastPageReached = true;
        }
        finally {
            this.isLoading = false;
        }
    }
    async getEdgeContacts() {
        const skip = this.edgeContacts.length;
        const pageContacts = await this.ContactsJourneyService.getEdgeContacts(this.searchPeriod, this.selectedEdge, this.dataSource, this.firstNode, skip, CONTACTS_USERS_PER_TAKE);
        const mergedContacts = this.edgeContacts.concat(pageContacts);
        this.edgeContacts = mergedContacts;
        this.setChannelsImagesToEdgeContacts();
    }
    async downloadCSV() {
        let behavior = SUCCESS_STATUS;
        let fileSize = 0;
        try {
            this.isGeneratingCSV = true;
            const dataCsv = await this.ContactsJourneyService.getJourneyCSVData(this.searchPeriod, this.selectedEdge, this.dataSource, this.firstNode);
            fileSize = dataCsv?.size ? dataCsv.size : 0;
            if (dataCsv?.uri) {
                window.open(dataCsv.uri, '_blank');
            }
            else {
                throw new TypeError('Invalid uri.');
            }
        }
        catch (err) {
            this.ngToast.danger(await this.TranslateService.instantTranslate(EXPORT_ERROR_MESSAGE));
            behavior = FAILURE_STATUS;
        }
        finally {
            this.isGeneratingCSV = false;
            this.trackCSVDownloadEvent(behavior, fileSize);
        }
    }
    async checkFeatures() {
        this.isActiveMessageButtonEnabled = await ActiveMessagesFeatures.isActiveMessagesOnContactsJourneyEnabled();
    }
    async generateAudience() {
        try {
            const url = await this.ActiveMessageService.createAudience(this.edgeContacts);
            const stepName = toCamelCase(this.selectedEdgeName.split('[')[0]);
            const ownerIdentity = this.$state.params.shortName;
            const dateTime = await moment().format(FILE_NAME_DATE_FORMAT);
            const fileName = `${APPLICATION_ORIGIN}_${ownerIdentity}_${stepName}_${dateTime}.csv`;
            createJourneyTrack(this.SegmentService, this.application, GROWTH_ACTIVE_MESSAGE_WA_SENT_ACTIVE_MESSAGE_BUTTON_CLICKED, { applicationOrigin: APPLICATION_ORIGIN });
            this.$state.go(ActiveMessagesConstants.SEND_ACTIVE_MESSAGE_STATE, {
                fileName,
                mediaUrl: url,
                applicationOrigin: APPLICATION_ORIGIN,
            });
        }
        catch (e) {
            this.BlipToastService.show('danger', {
                title: await this.TranslateService.instantTranslate(ERROR_GENERATING_AUDIENCE_TITLE),
                msg: await this.TranslateService.instantTranslate(ERROR_GENERATING_AUDIENCE_BODY),
                buttonText: await this.TranslateService.instantTranslate(REFRESH_BUTTON_TEXT),
                callback: () => this.$state.reload(),
                duration: 19000,
            });
        }
    }
    trackCSVDownloadEvent(behavior, fileSize) {
        const nodeType = this.selectedEdge.type;
        const nodeName = this.selectedEdge.name;
        const usersCount = this.selectedNodeUsersCount;
        const contactsDownloadedTrackBody = {
            behavior,
            nodeType,
            nodeName,
            usersCount,
            fileSize,
        };
        createJourneyTrack(this.SegmentService, this.application, DOWNLOAD_CONTACTS_TRACK, contactsDownloadedTrackBody);
    }
}
ContactsJourneySideBarController.$inject = ['SidebarContentService', 'selectedEdge', 'searchPeriod', 'firstNode', 'dataSource', 'selectedNodeUsersCount', 'ContactsJourneyService', '$state', '$window', 'UsersService', 'SegmentService', 'application', '$timeout', 'isShowingCSVExportButton', 'ngToast', 'TranslateService', 'ActiveMessageService', 'GrowthSegmentService', 'BlipToastService'];
